const logo = '../../../assets/images/logo.png'

export const metaContent = {
  home: {
    title: "Gapalyze | Amazon Seller Analytics & FBA Profit Dashboard",
    description:
      "Transform complex Amazon Seller Central reports into clear, actionable insights. Track real-time profits, ad performance, and geographic sales data with Gapalyze. Secure SP-API integration.",
    canonical: "https://www.gapalyze.com/",
    keywords:
      "Amazon seller analytics, FBA profit dashboard, Amazon PPC tool, Gapalyze, Amazon business reports, FBA accounting software, Amazon India seller tools",
    image: logo,
  },

  about: {
    title: "About Us | Gapalyze – Empowering Amazon Sellers with Smart Analytics",
    description:
      "Learn about Gapalyze’s mission to simplify Amazon data analytics. Discover how we help sellers track profits, optimize advertising, and grow their FBA business with data-driven insights.",
    canonical: "https://www.gapalyze.com/about-us",
    keywords:
      "about gapalyze, amazon analytics team, FBA data experts, seller insights platform",
    image: logo,
  },

  pricing: {
    title: "Pricing – Gapalyze Plans for Amazon Sellers",
    description:
      "Choose the perfect Gapalyze plan for your Amazon business. Simple, transparent pricing with powerful analytics features, profit tracking, and ads optimization tools.",
    canonical: "https://www.gapalyze.com/pricing",
    keywords:
      "gapalyze pricing, amazon analytics pricing, FBA tool pricing, seller tool plans",
    image: logo,
  },

  privacyPolicy: {
    title: "Privacy Policy – Gapalyze",
    description:
      "Read Gapalyze’s Privacy Policy to understand how we securely manage and protect your Amazon Seller data through encrypted SP-API integration and cloud security measures.",
    canonical: "https://www.gapalyze.com/privacy-policy",
    keywords: "gapalyze privacy policy, data security, amazon seller data protection",
    image: logo,
  },

  termsCondition: {
    title: "Terms & Conditions – Gapalyze",
    description:
      "Review Gapalyze’s terms and conditions outlining service usage, responsibilities, account policies, and legal guidelines for Amazon sellers using our analytics tools.",
    canonical: "https://www.gapalyze.com/terms-condition",
    keywords: "gapalyze terms, amazon seller terms, fba tool legal terms",
    image: logo,
  },

  dataRetention: {
    title: "Data Retention Policy – Gapalyze",
    description:
      "Understand how Gapalyze manages, stores, and retains your Amazon SP-API data securely while complying with global data protection and privacy standards.",
    canonical: "https://www.gapalyze.com/data-retention",
    keywords:
      "data retention amazon, amazon seller data retention, gapalyze data policy",
    image: logo,
  },

  consentPolicy: {
    title: "Consent Policy – Gapalyze",
    description:
      "Gapalyze’s consent policy explains how user permissions and data authorizations work, ensuring compliance with Amazon SP-API and data privacy regulations.",
    canonical: "https://www.gapalyze.com/consent-policy",
    keywords: "gapalyze consent policy, amazon data consent",
    image: logo,
  },

  cookiePolicy: {
    title: "Cookie Policy – Gapalyze",
    description:
      "Learn how Gapalyze uses cookies to enhance user experience, optimize analytics, and deliver faster performance across our Amazon seller dashboard.",
    canonical: "https://www.gapalyze.com/cookie-policy",
    keywords: "gapalyze cookie policy, tracking cookies, analytics cookies",
    image: logo,
  },

  crossBorderData: {
    title: "Cross Border Data Policy – Gapalyze",
    description:
      "Gapalyze ensures secure cross-border data transfer by following international compliance standards and Amazon SP-API guidelines for global sellers.",
    canonical: "https://www.gapalyze.com/cross-border-data-policy",
    keywords:
      "cross border data amazon, global data compliance, FBA international policy",
    image: logo,
  },

  grievancePolicy: {
    title: "Grievance Policy – Gapalyze",
    description:
      "Review Gapalyze’s grievance redressal policy for reporting issues, receiving support, and resolving concerns related to our Amazon analytics platform.",
    canonical: "https://www.gapalyze.com/grievance-policy",
    keywords: "gapalyze grievance, complaint policy, amazon seller issues",
    image: logo,
  },

  indiaSpecificPolicy: {
    title: "India-Specific Privacy Policy – Gapalyze",
    description:
      "Gapalyze complies with Indian data protection regulations while processing Amazon seller insights. Learn about our India-specific privacy practices.",
    canonical: "https://www.gapalyze.com/india-specific-policy",
    keywords:
      "india privacy policy amazon, gapalyze india data policy, fba compliance india",
    image: logo,
  },

  blog: {
    title: "Gapalyze Blog – Amazon Seller Guides, Tips & Analytics Insights",
    description:
      "Explore expert articles on Amazon selling, analytics strategies, PPC optimization, FBA business scaling, and data-driven seller growth.",
    canonical: "https://www.gapalyze.com/blog",
    keywords:
      "amazon seller tips, FBA guides, amazon ppc blog, analytics tutorials",
    image: logo,
  },

  blogDetails: (id, title, description, image) => ({
    title: `${title} | Gapalyze Blog`,
    description,
    canonical: `https://www.gapalyze.com/blog-details/${id}`,
    keywords: `${title}, amazon blog, fba blog, seller insights`,
    image,
  }),

  contact: {
    title: "Contact Us – Gapalyze Support",
    description:
      "Get in touch with Gapalyze support for assistance with Amazon seller analytics, onboarding, technical issues, or general business inquiries.",
    canonical: "https://www.gapalyze.com/contact",
    keywords: "gapalyze support, contact gapalyze, amazon tool support",
    image: logo,
  },

  faq: {
    title: "FAQ – Frequently Asked Questions | Gapalyze",
    description:
      "Find answers to common questions about Gapalyze features, Amazon SP-API integration, pricing, analytics tools, and seller insights.",
    canonical: "https://www.gapalyze.com/faq",
    keywords:
      "gapalyze faq, amazon analytics faq, fba questions, seller tool help",
    image: logo,
  },
  // AUTH & PUBLIC ROUTES
  signin: {
    title: "Sign In – Gapalyze",
    description:
      "Access your Gapalyze account and view your Amazon Seller analytics dashboard securely. Login to manage profits, ads, and sales insights.",
    canonical: "https://www.gapalyze.com/signin",
    keywords: "gapalyze login, amazon analytics login, seller dashboard login",
    image: logo,
    noIndex: true,
  },

  signup: {
    title: "Create Account – Gapalyze",
    description:
      "Sign up for Gapalyze to unlock data-driven Amazon Seller analytics, real-time profit tracking, FBA insights, and ad performance tools.",
    canonical: "https://www.gapalyze.com/signup",
    keywords: "gapalyze signup, create account, amazon seller tool signup",
    image: logo,
    noIndex: true,
  },

  forgotPassword: {
    title: "Forgot Password – Gapalyze",
    description:
      "Reset your Gapalyze account password securely to regain access to your Amazon Seller analytics dashboard.",
    canonical: "https://www.gapalyze.com/forgot-password",
    keywords: "gapalyze forgot password, reset account password",
    image: logo,
    noIndex: true,
  },

  resetPassword: {
    title: "Reset Password – Gapalyze",
    description:
      "Set a new password for your Gapalyze account and restore secure access to your Amazon Seller insights and data.",
    canonical: "https://www.gapalyze.com/reset-password",
    keywords: "gapalyze reset password, amazon tool password reset",
    image: logo,
    noIndex: true,
  },

  unlockAccount: {
    title: "Unlock Account – Gapalyze",
    description:
      "Unlock your Gapalyze account securely and regain access to Amazon analytics tools and seller insights.",
    canonical: "https://www.gapalyze.com/unlock-account",
    keywords: "gapalyze unlock account, account locked, amazon seller unlock",
    image: logo,
    noIndex: true,
  },

  forgotPasswordOtp: {
    title: "Verify OTP – Gapalyze",
    description:
      "Enter the OTP sent to your email to complete your password recovery process and regain access to Gapalyze.",
    canonical: "https://www.gapalyze.com/forgot-password-otp",
    keywords: "gapalyze otp verification, password otp, amazon seller otp",
    image: logo,
    noIndex: true,
  },

  confirm: {
    title: "Thank You – Gapalyze",
    description:
      "Your action has been completed successfully. Proceed to login and continue using Gapalyze Amazon analytics tools.",
    canonical: "https://www.gapalyze.com/confirm",
    keywords: "gapalyze thank you, account confirmed, success page",
    image: logo,
    noIndex: true,
  },

};
